import React, { useState } from "react";
import PropTypes from 'prop-types'
import { Box, Text, TextInput, Row, Col, FillButton } from 'tailwind-react-ui';
import { connect } from 'react-redux';
import EmailStatusMessage from './EmailStatusMessage';
import * as email  from '../api/controller/email';
import * as safety  from '../api/controller/safety';
import reCaptchaConfig from '../config/reCaptchaConfig';

function EmailModalComponent({showModal, setShowModal, coupon, message}){

    const [form, setValues] = useState({
        email: '',
        statusMail:"default"
    });

    const handleInput = (event) => {
        setValues({
            ...form,
            [event.target.name]: event.target.value,
        });
    };

    function sendEmailAction(){
        var emailAddress = form.email;
        var customer = {email:emailAddress, coupon:coupon};
        var statusOfEmail = "loading";
        setValues({
            email:emailAddress,
            statusMail: statusOfEmail,
        });
        email.sendCoupon(customer).then(res =>{
            console.log("sendCoupon ....");
            console.log(res);
            if(res.success){
                statusOfEmail = "success";
            }else {
                statusOfEmail = "error";
                emailAddress = "";
            }
            setValues({
                email:emailAddress,
                statusMail: statusOfEmail,
            });
        });
    }

    function safetyRecaptcha (token){
        var email = form.email;
        const statusOfEmail = "error";
        setValues({
            email:email,
            statusMail: "loading",
        });
        safety.verifyRecaptcha(token).then(res => {
            console.log("verifyRecaptcha response:");
            console.log(res);
            if(res.success){
                if(parseFloat(res.data.score) >= 0.5 ){
                    if(email != ""){
                        sendEmailAction();
                    }else{
                        console.log("email empty!!");
                        setValues({
                            email:"",
                            statusMail: statusOfEmail,
                        });
                    }
                }else{
                    console.log("score recatpcha fail!!");
                    setValues({
                        email:"",
                        statusMail: statusOfEmail,
                    });
                }
            }else{
                console.log("verify recaptcha error!!");
                setValues({
                    email:"",
                    statusMail: statusOfEmail,
                });
            }
        });
    }

    function closeModal (statusOfEmail){
        setShowModal(!showModal);
        setValues({
            email:"",
            statusMail: statusOfEmail,
        });
    }

    function onClickSend(e) {
        e.preventDefault();
        window.grecaptcha.ready(function() {
           window.grecaptcha.execute(reCaptchaConfig.siteKey, {action: 'send_coupon'}).then(function(token) {
            console.log(token);
            safetyRecaptcha(token);
          });
        });
    }

    return (
    <>
        { showModal ? (
        <>
            <Box    
            className="justify-center fixed px-8 items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <Box onClick={() => setShowModal(!showModal)} className="absolute w-full h-full" style={{ backgroundColor: 'rgba(27, 27, 27, 0.75)' }}/>
                <Box className="relative w-auto my-6 mx-auto max-w-xl ">
                    {/*content*/}
                    <Box className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        {/*header*/}
                       {{   default:<>
                                    <Box className="flex items-start justify-between rounded-t">
                                        <Text is="p" text={['dark-light-gray', 'left']} className="quicksand-bold text-2xl mx-5 mt-5 ">
                                            {message.default}
                                        </Text>
                                        <button
                                            className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => setShowModal(!showModal)}>
                                            <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                            ×
                                            </Text>
                                        </button>
                                    </Box>
                                    <form action="" method="" onSubmit={onClickSend}>
                                        <Box inlineBlock m={{t:5}} text={['dark-gray', 'left']} className="quicksand-regular relative w-full px-6 flex-auto">
                                            <Row>
                                                <Col p={1} align={'middle'} className="w-full sm:w-1/5 md:w-1/5 lg:w-1/5">
                                                    <Text is="p" className="sm:mt-2 text-gray-600 text-xl leading-relaxed">
                                                        Email
                                                    </Text>
                                                </Col>
                                                <Col p={1} className="w-full sm:w-4/5 md:w-4/5 lg:w-4/5">
                                                    <TextInput 
                                                    name={"email"}
                                                    type={'email'}
                                                    style={{borderColor: '#9d9d9d'}} 
                                                    className="select-auto" 
                                                    placeholder="Escribe tu email" 
                                                    onChange={handleInput}
                                                    m={'auto'}
                                                    h={12}
                                                    required
                                                    p={2}/>
                                                </Col>
                                            </Row>
                                        </Box>
                                        <Box className="flex items-center justify-end p-6 rounded-b">
                                            <FillButton 
                                            id="send" 
                                            type={'submit'}
                                            className="quicksand-bold border-0 w-full sm:w-2/5 g-recaptcha" 
                                            h={12}
                                            bg={'yellow'}
                                            style={{borderWidth: '0'}}
                                            text={['dark-purple', 'middle']}
                                            data-sitekey={reCaptchaConfig.siteKey} 
                                            data-callback='onClickSend' 
                                            data-action='submit'
                                            >
                                                ENVIAR
                                            </FillButton>
                                        </Box>
                                    </form>
                                    </>,
                            error:  <>
                                    <Box className="flex items-start justify-between rounded-t">
                                        <button
                                            className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => closeModal('default')}>
                                            <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                            ×
                                            </Text>
                                        </button>
                                    </Box>
                                    <EmailStatusMessage message={message.error} srcImg={"https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/envio-fallo.png"}/>
                                    </>,
                            success: <>
                                    <Box className="flex items-start justify-between rounded-t">
                                        <button
                                            className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => closeModal('default')}>
                                            <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                            ×
                                            </Text>
                                        </button>
                                    </Box>
                                    <EmailStatusMessage message={message.success} srcImg={"https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/envio-correcto.png"}/>
                                    </>,
                            loading: <>
                                    <Box className="flex items-start justify-between rounded-t">
                                        <button
                                            className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => closeModal('default')}>
                                            <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                            ×
                                            </Text>
                                        </button>
                                    </Box>
                                    <EmailStatusMessage message={"Envíando cupón ..."} srcImg={"https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/cargando.gif"}/>
                                    </>,
                        }[form.statusMail]}
                    </Box>
                </Box>
            </Box>
            <Box className="opacity-25 fixed inset-0 z-40 bg-black"/>
        </>
        ) : null}
    </>
    );
}

EmailModalComponent.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func, 
    coupon: PropTypes.string,
    message: PropTypes.node,
}

EmailModalComponent.defaultProps = {
    showModal: false, 
    coupon: "SIXTYCHELAS01",
    message:{
        default: "Ingresa tu correo electrónico para enviarte tu cupón.",
        error: "¡Error de envío!",
        success: "¡Envío exitoso!",
    },
}

const mapStateToProps = state => {
    return {
        coupon:state.coupon.code,
    };
};

export default connect(mapStateToProps, null)(EmailModalComponent);
